import script from "./politicasReembolsoGST.vue?vue&type=script&setup=true&lang=js"
export * from "./politicasReembolsoGST.vue?vue&type=script&setup=true&lang=js"

import "./politicasReembolsoGST.vue?vue&type=style&index=0&id=6b40bc60&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b40bc60"]])

export default __exports__